import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import SectionHeading from '../../../components/text/SectionHeading';
import SectionHeadingWrapper from '../../../components/text/SectionHeading/HeadingWrapper';
import CollegeHSClubCard from '../../../components/cards/CollegeHSClubCard';

import { getDashboardHighSchools, applySearchFilters } from '../../../actions/search-actions';

const HighSchoolsNearMe = (props) => {
    // component props
    const { filterPreferences, auth } = props;
    // redux mapping
    const { highSchools = [], loading } = props;

    useEffect(() => {
        if (!highSchools.length && !loading) {
            props.getDashboardHighSchools(filterPreferences);
        }
    }, [filterPreferences]);

    const onViewAllClick = () => {
        const { location, lat, lng, utrMin = 1, utrMax = 16, distance, gender } = filterPreferences;
        props.applySearchFilters({
            type: 'highSchools',
            startDate: moment(new Date()),
            distance,
            location,
            lat,
            lng,
            utrMin,
            utrMax,
            gender,
        }, true);
        props.history.push('/search');
    };
    const showTennisContent = auth?.feedPreferences?.showTennisContent;

    if (!!showTennisContent) {
        return (
            <div>
                <div className="row mt64">
                    <div className="col-12">
                        <SectionHeadingWrapper>
                            <SectionHeading title={'High Schools Near Me'} data-testid="dashboard.high-schools-near-me.section-heading" />
                            <div className={`link clickable`} onClick={onViewAllClick} data-testid="dashboard.high-schools-near-me.view-all-btn">
                                View All
                            </div>
                        </SectionHeadingWrapper>
                    </div>
                </div>
                <div className="row">
                    {highSchools.length ? (
                        highSchools.map((highSchool, i) => {
                            return (
                                <div className={`col-12 col-md-4`} key={`college-${i}`}>
                                    <CollegeHSClubCard club={highSchool.source} force={{ cardView: true }} data-testid={`dashboard.high-schools-near-me.item-${highSchool.source.id}`} />
                                </div>
                            );
                        })
                    ) : (
                        <div className="col" data-testid="dashboard.high-schools-near-me.empty-message">There are no high schools in your area</div>
                    )}
                </div>
            </div>
        );
    }
    return null;
};

function mapStateToProps({ homepage, auth }) {
    const { highSchools = {} } = homepage;
    const { data, loading, error } = highSchools;
    return { highSchools: data, loading, error, auth };
}
const mapDispatchToProps = {
    getDashboardHighSchools,
    applySearchFilters,
};

HighSchoolsNearMe.propTypes = {
    auth: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HighSchoolsNearMe));
